import * as B from '@blueprintjs/core';
import React from 'react';

import type {PaymentNotice} from 'app/modules/Cart';

/**
 * A card charge that didn't go through. Separate from the cart's failure banners, which mean the
 * server turned the checkout down: here it tried the card, and since nothing is ordered unless the
 * charge is paid, the scenes are still in the cart.
 */
export const PaymentNotices: React.FC<{notices: PaymentNotice[]}> = ({notices}) => (
  <>
    {notices.map((notice) => (
      <B.Callout
        key={`${notice.title}~${notice.message}`}
        intent={notice.tone === 'danger' ? B.Intent.DANGER : B.Intent.WARNING}
        icon={notice.tone === 'danger' ? 'error' : 'time'}
        title={notice.title}
      >
        {notice.message}
      </B.Callout>
    ))}
  </>
);

export default PaymentNotices;
